import {
  readSourceFilterFromUrl,
  MCP_SOURCE_FILTER_URL_PARAM,
  type MCPSourceFilterValue,
} from './sourceFilter';
import { useBareUrlParam } from './useBareUrlParam';

type MCPSource = Exclude<MCPSourceFilterValue, null>;

function parseSource(raw: string | null): MCPSource | null {
  const params = new URLSearchParams();
  if (raw !== null) params.set(MCP_SOURCE_FILTER_URL_PARAM, raw);
  return readSourceFilterFromUrl(params);
}

/**
 * Reads/writes the MCP source-filter selection from the bare `pr` URL param
 * (KIR-3940). Deliberately outside DataTable's `inv-mcp.`-namespaced state —
 * the filter is a bespoke 3-button control, not a registered column.
 */
export function useMcpSourceFilter(): {
  source: MCPSourceFilterValue;
  setSource: (next: MCPSourceFilterValue) => void;
} {
  const [source, setSource] = useBareUrlParam(
    MCP_SOURCE_FILTER_URL_PARAM,
    parseSource
  );
  return { source, setSource };
}
